import MainEngineType from "@/model/MainEngineType";
import AuxEngineType from "@/model/AuxEngineType";
import EconomicData from "./EconomicData";
import MainEngineEnergySavingsType from "./MainEngineEnergySavingsType";
import AuxEngineEnergySavingsType from "./AuxEngineEnergySavingsType";

class Configuration {
  public id: string = "";
  public name: string = "";
  public description: string = "";
  public isBase: boolean = false;
  public attainedEEXI: number = 0;
  public logElement: Array<string> = new Array<string>();

  public MainEngineEmissions = new Array<MainEngineType>();
  public AuxiliaryEngineEmissions = new Array<AuxEngineType>();
  public MainEngineEnergySavings = new Array<MainEngineEnergySavingsType>();
  public AuxiliaryEngineEnergySavings = new Array<AuxEngineEnergySavingsType>();

  public vref: number = 0;
  public vref_calc: string = "";

  public fj: number = 0;
  public fj_unapply: boolean = false;

  public fc: number = 0;
  public fc_unapply: boolean = false;

  public fm: number = 0;
  public fm_unapply: boolean = false;

  public fw: number = 0;
  public fw_unapply: boolean = false;

  public fl: number = 0;
  public fl_unapply: boolean = false;

  public fi: number = 0;
  public fi_unapply: boolean = false;

  public modified_gt: number | null = 0;
  public modified_dwt: number | null = 0;
  public modified_required_EEXI: number | null = null;

  public forceVRefCalc: boolean = false;

  public economicData: EconomicData = new EconomicData();
}

export default Configuration;
